import { useEffect, useState, useRef } from 'react';

export function useVisibleCategory(menuItems: any[] = []) {
  const [activeCategory, setActiveCategory] = useState<string>('All');
  const observer = useRef<IntersectionObserver | null>(null);
  const visibleCategories = useRef(new Map<string, number>());

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const categoryId = entry.target.getAttribute('data-category-id');
          if (!categoryId) return;

          if (entry.isIntersecting) {
            const currentCount = visibleCategories.current.get(categoryId) || 0;
            visibleCategories.current.set(categoryId, currentCount + 1);
          } else {
            const currentCount = visibleCategories.current.get(categoryId) || 0;
            if (currentCount > 0) {
              visibleCategories.current.set(categoryId, currentCount - 1);
            }
          }
        });

        let maxCount = 0;
        let mostVisibleCategory = 'All';

        visibleCategories.current.forEach((count, categoryId) => {
          if (count > maxCount) {
            maxCount = count;
            mostVisibleCategory = categoryId;
          }
        });

        if (maxCount > 0) {
          setActiveCategory(mostVisibleCategory);
        }
      },
      {
        root: null,
        rootMargin: '-120px 0px -50% 0px',
        threshold: [0, 0.5, 1],
      }
    );

    const observeItems = () => {
      observer.current?.disconnect();
      visibleCategories.current.clear();

      const menuItemCards = document.querySelectorAll('[data-category-id]');
      menuItemCards.forEach((card) => {
        observer.current?.observe(card);
      });
    };

    const timeoutId = setTimeout(observeItems, 500);

    return () => {
      clearTimeout(timeoutId);
      observer.current?.disconnect();
    };
  }, [menuItems.length]);

  return activeCategory;
}
